import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import Cookies from 'js-cookie'
import { COOKIE_KEY } from '../../constants'
import { CurrentUserResponse, type AuthResponse } from '../user/user.type'

const initialState: AuthResponse = {
  user: null,
  signedIn: false,
  token: undefined,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateAuthStatus: (state: AuthResponse, action: PayloadAction<boolean>) => {
      state.signedIn = action.payload
    },
    setAuthUserData: (state, action) => {
      state.user = action.payload.stakeholder
      state.token = action.payload.token
      state.signedIn = true
      Cookies.set(COOKIE_KEY, action.payload.token)
    },
    signOut: (state: AuthResponse & { currentCart?: string }) => {
      state.user = null
      state.signedIn = false
      state.token = undefined
      state.currentCart = undefined
      Cookies.remove(COOKIE_KEY)
    },
    updateUserNoAuth: (state, action: PayloadAction<CurrentUserResponse>) => {
      state.user = action.payload
    },
  },
})

export const { updateAuthStatus, setAuthUserData, signOut } = authSlice.actions
export default authSlice.reducer
